<template>
  <article
      class="applications__card" :class="'application-status_' + item.applicationStatusNameClass"
      itemscope
      itemtype="http://schema.org/NewsArticle">
    <div class="applications__item applications__header">
      <div v-if="orgType === 'SubOrg'">
        <div class="applications__title">
          Головная организация: <span>{{ headOrgName }}</span>
        </div>
        <div class="applications__title">
          Филиал: <span>{{ filialName }}</span>
        </div>
      </div>
      <div class="applications__title" v-else>
        Организация: <span>{{ orgName }}</span>
      </div>
      <div class="applications__id">ID заявки:<span>{{ item.id }}</span></div>
      <div class="applications__date">Дата создания:<span>{{ createDate }}</span></div>
    </div>

    <div class="applications__item applications__content">
      <div class="applications__type" v-if="orgType === 'SubOrg'">
        <div :class="['application-type', 'application-type_' + item.applicationStatusNameClass]">
          <span>{{ item.applicationStatus }}</span>
          <span>{{ item.applicationTypeName }}</span>
        </div>
      </div>
      <v-btn class="white__v-btn"
             @click="$emit('aboutApplication', item)"><span
          class="v-btn__content">Подробно об изменениях</span></v-btn>
      <!--<button class="button_mini" @click="getDocument">Подтверждающий документ</button>-->
    </div>

    <div class="applications__item applications__actions">
      <v-btn icon @click="resolve" v-if="item.applicationStatus">
        <v-icon :size="24" color="success" class="fr-topbar__icon">mdi-check-bold</v-icon>
      </v-btn>
      <v-btn icon @click="reject" v-if="item.applicationStatus">
        <v-icon :size="24" color="error" class="fr-topbar__icon">mdi-cancel</v-icon>
      </v-btn>
    </div>
  </article>
</template>

<script>

export default {
  name: 'CardOrgApplication',
  props: {
    item: {
      type: Object,
    },
    orgType: {
      type: String,
    }
  },
  computed: {
    createDate() {
      return this.item.createDate
    },
    headOrgName() {
      return `(ID: ${this.item?.owner?.id}) ${this.item?.ownerName}`
    },
    filialName() {
      if (this.item?.orgId && this.item?.org?.name) {
        return `(ID: ${this.item?.orgId}) ${this.item?.org?.name}`
      } else if (this.item?.nameShort) {
        return `${this.item.nameShort}`
      } else {
        return ``
      }
    },
    orgName() {
      if (this.item?.orgId && this.item?.org?.name) {
        return `(ID: ${this.item.orgId}) ${this.item.org.name}`
      } else if (this.item?.nameShort) {
        return `${this.item.nameShort}`
      } else {
        return ``
      }
    }
  },
  methods: {
    reject() {
      this.$emit('reject', this.item.id);
    },
    resolve() {
      this.$emit('resolve', this.item.id);
    },
  },

}
</script>
<style lang="sass">
</style>